const digest = '6bcd73845433917a9cc16fa78d4420f538bf5f4db5ab9b4f14e4a8b68d1b0a33';
const css = `._calendarFooter_cand9_1{border-top:1px solid #e0e0e0;display:flex;justify-content:space-between}._minStay_cand9_7{padding:.5rem 0}._doneButton_cand9_11{min-width:max-content!important}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'calendarFooter': '_calendarFooter_cand9_1', 'minStay': '_minStay_cand9_7', 'doneButton': '_doneButton_cand9_11' };
export const calendarFooter = '_calendarFooter_cand9_1';
export const minStay = '_minStay_cand9_7';
export const doneButton = '_doneButton_cand9_11';
export { css, digest };